import { useQuery } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { AsOfStrip } from '@/components/common/AsOfStrip';
import { ErrorMessage, SkeletonLoader } from '@/components/common/StateViews';
import { ContestedItemsTable } from '@/pages/anatel/conselho/ContestedItemsTable';
import { fetchAnatelConselhoItems } from '@/services/anatel';

/**
 * Every contested (acórdão, alínea): the record the positions are estimated
 * from. Reached from the bench page, not from the menu.
 */
export function AnatelConselhoItemsPage() {
  const { t, i18n } = useTranslation(['anatel', 'common']);
  const { data, isPending, error, refetch } = useQuery({
    queryKey: ['anatel', 'conselho', 'items'],
    queryFn: fetchAnatelConselhoItems,
  });
  if (isPending) {
    return (
      <div className="space-y-4 p-6">
        <SkeletonLoader rows={8} />
      </div>
    );
  }
  if (error) {
    return (
      <div className="p-6">
        <ErrorMessage message={error.message} onRetry={() => void refetch()} />
      </div>
    );
  }
  const number = new Intl.NumberFormat(i18n.language);
  return (
    <div className="space-y-4 p-6">
      <Link to="/anatel/conselho" className="inline-flex items-center gap-1 text-xs text-primary underline-offset-4 hover:underline">
        <ArrowLeft className="h-3.5 w-3.5" aria-hidden />
        {t('anatel:conselho.title')}
      </Link>
      <header className="space-y-1">
        <h1 className="text-lg font-semibold text-foreground">{t('anatel:conselho.items.title')}</h1>
        <p className="text-sm text-muted-foreground">{t('anatel:conselho.items.help')}</p>
      </header>
      <AsOfStrip asOf={data.as_of} />
      <p className="text-xs text-muted-foreground" data-total={data.total}>
        {number.format(data.total)}
      </p>
      <ContestedItemsTable items={data.items} />
    </div>
  );
}
